import { render } from "./ServiceProviderDashboardPage.vue?vue&type=template&id=2d3cb287"
import script from "./ServiceProviderDashboardPage.vue?vue&type=script&lang=js"
export * from "./ServiceProviderDashboardPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__